export const sessionVariable ={
    token:"jwtToken",
    userInfo: "userInfo",
    companyProfile:"companyProfile",
    selectLease:"selectLease",
    flow:"flow",
}